var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.3307H7.5M18.3333 6.66406V9.9974M11.6667 6.66406V9.9974M11.5 23.3307H18.5C19.9001 23.3307 20.6002 23.3307 21.135 23.0582C21.6054 22.8186 21.9878 22.4361 22.2275 21.9657C22.5 21.4309 22.5 20.7309 22.5 19.3307V12.3307C22.5 10.9306 22.5 10.2305 22.2275 9.69575C21.9878 9.22535 21.6054 8.8429 21.135 8.60321C20.6002 8.33073 19.9001 8.33073 18.5 8.33073H11.5C10.0999 8.33073 9.3998 8.33073 8.86502 8.60321C8.39462 8.8429 8.01217 9.22535 7.77248 9.69575C7.5 10.2305 7.5 10.9306 7.5 12.3307V19.3307C7.5 20.7309 7.5 21.4309 7.77248 21.9657C8.01217 22.4361 8.39462 22.8186 8.86502 23.0582C9.3998 23.3307 10.0999 23.3307 11.5 23.3307Z",
    stroke: "#575756",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoster);
export default __webpack_public_path__ + "static/media/Roster.26a1bc9b2be0f1807fb2dc74bb829cbe.svg";
export { ForwardRef as ReactComponent };